import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExamsComponent } from './components/exams/exams.component';
import { ExamsService } from './services/exams.service';
import { ExamDetailsComponent } from './components/exam-details/exam-details.component';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { BackButtonModule } from '../../common/back-button/back-button.module';
import { ExamScheduledTestsComponent } from './exam-scheduled-tests/exam-scheduled-tests.component';
import { ExamPublishedTestsComponent } from './exam-published-tests/exam-published-tests.component';
import { PromotionReportComponent } from './components/promotion-report/promotion-report.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
    CommonModule,
    PerfectScrollbarModule,
    BackButtonModule
  ],
  declarations: [ExamsComponent, ExamDetailsComponent, ExamScheduledTestsComponent, ExamPublishedTestsComponent, PromotionReportComponent],
  providers: [ExamsService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }]
})
export class ExamsModule { }
